<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-toolbar class="headline gradiente lighten-2 elevation-3">
          <v-toolbar-title>
            <v-flex xs12>
              <div class="white--text">Agregar colaborador</div>
            </v-flex>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-flex pt-3 px-4>
          <v-text-field
            v-model="filters.search"
            label="Nombre del colaborador"
            append-icon="search"
            clearable
            @keyup.enter="getItems(true)"
          >
            <template v-slot:prepend>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">help</v-icon>
                </template>
                Nombre del colaborador
              </v-tooltip>
            </template>
          </v-text-field>
        </v-flex>
        <v-card-text id="contentParentsModal">
          <v-list subheader two-line>
            <v-subheader>Selecciona un colaborador</v-subheader>
            <template>
              <v-list-tile
                avatar
                v-for="(item, index) in parents"
                :key="item.id"
              >
                <v-list-tile-action>
                  <v-checkbox
                    color="primary"
                    :value="item"
                    :id="index + ''"
                    v-model="selectedItems"
                    v-bind:key="item.id"
                    @change="changeSelect"
                  ></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-avatar>
                  <v-icon>account_circle</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title
                    v-html="item.firstName + ' ' + item.lastName"
                  ></v-list-tile-title>
                  <v-list-tile-sub-title
                    v-html="item.mail"
                  ></v-list-tile-sub-title>
                  <v-divider :key="index" :inset="true"></v-divider>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="working.wUpdate" flat @click="cancel">
            {{ $t('students.modal_link_tutor.cancel') }}
          </v-btn>
          <v-btn
            :disabled="selectedItems.length === 0"
            color="primary darken-1"
            flat
            @click="submit"
          >
            {{ $t('students.modal_link_tutor.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['value', 'allowMany'],
  components: {},
  mounted() {},
  data: () => ({
    endInfiniteList: false,
    working: {
      wUpdate: false,
      wImage: false,
    },
    toast: {
      success: false,
      failed: false,
    },
    flags: {
      updateImage: false,
    },
    selectedItems: [],
    parents: [],
    totalParents: 0,
    filters: {
      lastSearch: '',
      size: 10,
      offset: 0,
      search: '',
    },
    isLoading: false,
  }),
  methods: {
    changeSelect() {
      if (this.allowMany) return
      if (this.selectedItems.length >= 1) {
        const temp = this.selectedItems[this.selectedItems.length - 1]
        this.selectedItems = [temp]
      }
    },
    text: (item) => item.mail,
    async handleScroll() {
      var event = document.getElementById('contentParentsModal')
      if (
        event.offsetHeight + event.scrollTop >= event.scrollHeight &&
        !this.isLoading
      ) {
        if (this.parents.length < this.totalParents) {
          this.filters.offset = this.parents.length + 1
          await this.getItems()
        }
      }
    },
    async getItems(enterSearch = false) {
      if (this.endInfiniteList === true) return
      if (enterSearch) {
        const temp = structuredClone(this.filters)
        this.filters.lastSearch = temp.search
        this.parents = []
        this.filters.offset = 0
      }
      const query = new URLSearchParams()
      query.set('pageSize', this.filters.size)
      query.set('offset', this.filters.offset)

      const params = {
        size: this.filters.size,
        space: false,
        offset: this.filters.offset,
        orderBy: 'NAME',
        orderType: 'ASC',
        search: this.filters.search,
      }
      this.isLoading = true
      try {
        const { data } = await this.$store.dispatch(
          'employee/getEmployees',
          params
        )

        if (this.filters.search === '') {
          this.parents = [...this.parents, ...data.data]
          this.totalParents = data.total
        } else {
          if (this.filters.search !== this.filters.lastSearch) {
            this.parents = []
            this.totalParents = data.total
          } else {
            this.parents = [...this.parents, ...data.data]
            this.totalParents = data.total
          }
        }

        if (data.data.length === 0) {
          this.endInfiniteList = true
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    cancel() {
      this.$emit('close', !this.value)
      this.close()
    },
    submit() {
      this.$emit('save', this.selectedItems)
    },
    close() {
      this.parents = []
      this.filters = {
        offset: 0,
        search: '',
        size: 10,
      }
      this.totalParents = 0
      this.endInfiniteList = false
      this.isLoading = false
      // this.$emit('close', !this.value)
    },
  },
  watch: {
    async value() {
      this.selectedItems = []
      if (this.value) {
        this.close()
        await this.getItems()
        document
          .getElementById('contentParentsModal')
          .addEventListener('scroll', this.handleScroll)
      }
    },
  },
}
</script>

<style>
.no-properties {
  width: 0% !important;
  height: 0% !important;
}
</style>
